<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-users">
      Email Templates
      <template v-slot:buttons>
        <v-btn color="primary"
               :to="{name: 'admin.groups.index'}"
               class="mr-2">
          Groups
        </v-btn>
        <v-btn :to="{name: 'admin.groups.membership_grid'}"
               class="mr-2">
          Group Membership
        </v-btn>
        <v-btn :to="{name: 'admin.groups.presentation_access_grid'}">
          Presentation Access
        </v-btn>
      </template>
    </page-title>

    <p v-if="initialized === false"
       class="text-center">
      <v-progress-circular indeterminate
                           size="64">
      </v-progress-circular>
    </p>

    <v-card v-else>
      <v-data-table id="data-table"
                    v-resize="adjustTableHeight"
                    :headers="headers"
                    :items="items"
                    :items-per-page="100"
                    :footer-props="{'items-per-page-options': [50, 100, 200]}"
                    :fixed-header="fixedHeader"
                    :height="tableHeight"
                    dense>
        <template v-slot:item="{index, item}">
          <tr>
            <td class="text-no-wrap">
              <v-chip v-if="item.is_active === false"
                      color="warning"
                      label
                      x-small
                      class="font-weight-bold">
                INACTIVE
              </v-chip>
              {{ item.name }}
            </td>
            <td v-for="group in item.groups"
                :key="group.id"
                class="text-center">
              <v-simple-checkbox v-model="group.checked"
                                 @click="toggleAccess(group, item)">
              </v-simple-checkbox>
            </td>
            <td class="text-no-wrap">
              <v-chip v-if="item.is_active === false"
                      color="warning"
                      label
                      x-small
                      class="font-weight-bold">
                INACTIVE
              </v-chip>
              {{ item.name }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style>
.NameCell {
  max-width: 300px;
  /*white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis !important;*/
}
</style>
<script>
import {mapGetters} from 'vuex';
import axios from '../../services/axiosService';
import DOMPurify from 'dompurify';
import PageTitle from '../../components/PageTitle.vue';
import shareTemplateService from '../../../../ml/services/shareTemplateService';

export default {
  components: {PageTitle},
  metaInfo() {
    this.$store.commit('setTitle', 'Groups - Email Template Access');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      busy: false,
      initialized: false,
      items: [],
      tableHeight: '600px',
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'loadingGroups',
      'shareTemplates', // MLD-6865
      'team',
    ]),
    fixedHeader() {
      if (this.initialized === false) {
        return false;
      }
      return this.items.length > 50;
    },
    headers() {
      if (this.initialized === false) {
        return [];
      }
      const headers = [];
      headers.push({
        text: '',
        value: 'name',
      })
      this.groups.forEach(g => {
        headers.push({
          text: g.name,
          value: g.slug,
          sortable: false,
        })
      })
      headers.push({
        text: '',
        value: 'name',
      })
      return headers;
    },
    isLoading() {
      return this.loadingGroups
    },
  },
  watch: {
    isLoading: function (newValue) {
      if (newValue === false) {
        this.initializeItems();
      }
    }
  },
  async created() {
    await this.fetchData(); // MLD-6696
  },
  mounted() {
    this.initializeItems();
  },
  methods: {
    adjustTableHeight() {
      if (this.fixedHeader === false) {
        this.tableHeight = null;
        return null;
      }
      let offsetTop = 250;
      const tbody = document.querySelector('#data-table tbody');
      if (tbody) {
        const tbodyTop = tbody.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        //console.log(`The tbody top is at ${tbodyTop}`);
        //console.log(`The window height ${windowHeight}`);
        const tableHeight = `${windowHeight - tbodyTop - 30}px`;
        //console.log(`The table height is ${tableHeight}`);
        this.tableHeight = tableHeight;
      } else {
        //console.log('offsetTop = ', offsetTop);
        this.tableHeight = `calc(100vh - ${offsetTop}px)`;
      }
    },
    async fetchData() { // MLD-6696

    },
    initializeItems() {
      if (this.isLoading === false) {
        const items = [];
        this.shareTemplates.filter(t => t.is_active).forEach(template => {
          const item = {
            id: template.id,
            name: template.name,
            groups: [],
            is_active: template.is_active,
          }
          this.groups.forEach(g => {
            const groupItem = {
              id: g.id,
              name: g.name,
              checked: g.templates?.map(p => p.id).includes(template.id),
              is_all_users: g.is_all_users,
            }
            item[g.slug] = groupItem;
            item.groups.push(groupItem);
          })
          items.push(item);
        })
        this.items = items;
        this.initialized = true;
        this.adjustTableHeight();
      }
    },
    toggleAccess(group, template) {
      return axios.post(`/api/groups/${group.id}/share-templates/${template.id}/toggle`)
        .then(response => {
          if (response.data?.message) {
            this.$toast.success(DOMPurify.sanitize(response.data.message));
          }
          this.$store.dispatch('fetchGroup', group.id);
          this.$store.dispatch('fetchShareTemplate', template.id)
        })
        .catch(err => {
          if (err.response.data?.message) {
            this.$toast.error(DOMPurify.sanitize(err.response.data.message));
          }
        })
    },
  },
}
</script>
